/**
 * Created by Paul on 6/2/2017.
 */
import {Component, Input} from '@angular/core';
import {LotteryPage} from "../../../pages/lottery/lottery";
import {SixMarkBaseComponent} from "../sixMarkBase";

@Component({
  selector: 'sm-animals',
  templateUrl: './sixMarkAnimals.html',
})

/**
 * mname: SM02
 * The game has 9 animals, each one has its own list of numbers.
 */
export class SixMarkAnimalsComponent extends SixMarkBaseComponent {
  // List of animals - each has name and its list of numbers
  animals = [];

  @Input()
  set selectOption(selectOption: any) {
    if (selectOption) {
      this.animals = selectOption.no.animalsList;
      this.maxAmountPerOption = selectOption.no.maxAmountPerOption;
      this.maxAmountPerBet = selectOption.no.maxAmountPerBet;
      this._selectOption = selectOption;
    }
  }

  /**
   * Reset all status to the beginning of the game
   */
  resetGame() {
    // Reset bet coins of animals list
    this.resetBetCoins(this.animals);

    // Reset total
    this.onTotalChanged.emit(0);
  }

  /**
   * Get animal by code
   * @param code
   */
  getAnimalByCode(code: string) {
    let animal = this.animals.find(animal => animal.code === code);
    return animal;
  }

  /**
   * Remove a specific bets
   * @param bets
   */
  removeBets(bets = []) {
    bets.forEach(animalCode => {
      let animal = this.getAnimalByCode(animalCode);
      if (animal) {
        animal.betCoins.pop();
      }
    });
  }

  /**
   * Get an option by its code
   * @param optionCode
   */
  getOptionByCode(optionCode): any {
    return this.getAnimalByCode(optionCode)
  }

  /**
   * Bet selected animal
   * @param animal
   */
  betAnimal(animal: any) {
    if (animal) {
      this.addDefaultBetCoin(animal);

      // Set selected animal's code to current bet
      this.setCurrentBets([animal.code]);

      // Trigger popup
      this.onOptionSelected.emit();
      LotteryPage.clickPlay();
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/sixmark/animals/sixMarkAnimals.ts